import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import "./Contacts.css";
import { SHORE_BADGE_ICON, SHIP_BADGE_ICON } from "../../../utils/constants";
import { styled, Badge } from "@mui/material";
import { getColorForRankAndRoles } from "../../../utils/ColorMapping";
import { updateProfileImage } from "../../../state/actions/updateProfileImage";
import Avatar from "../../../components/common/Avatar";
import { getUserProfileImageUrlThumbnail, isValidImageUrl } from "../../../utils/general";

const StyledBadge = styled(Badge)(({ theme }) => ({
	"& .MuiBadge-badge": {
		right: "4px",
		bottom: "12px",
		transform: "scale(1) translate(50%, 50%)",
	},
}));



const ContactUIFunctional = ({
	contact,
	showRanks = true,
	userId,
	allProfileImages,
	userDomain,
}) => {
	const [profileImg, updateProfileImg] = useState("");
	const dispatch = useDispatch();


	let topElStyle = {
		height: "40px",
		width: 'auto',
		gap: '1rem'
	};

	const setProfileImg = (contact, userId, allProfileImages) => {
		if (contact.contactType === "local") {
			if (allProfileImages) {
				return allProfileImages[userId + contact.userId];
			}
		} else {
			if (allProfileImages) {
				return allProfileImages[contact.userId];
			}
		}
	};
	const getBadgeIcon = (contact) => {
		if (contact?.contactType === "local") return null;
		let { rankLevel1 } = contact;
		let rankLevel1SmallCase = (rankLevel1 || "").toLowerCase();

		let iconPath;
		switch (rankLevel1SmallCase) {
			case "shore":
				iconPath = SHORE_BADGE_ICON;
				break;
			case "ship":
				iconPath = SHIP_BADGE_ICON;
				break;
			default:
				iconPath = '';
		}
		return (iconPath &&
			<img loading="lazy" src={iconPath} alt={`${contact?.category} badge`} style={{ width: "100%" }} />
		);
	};

	let imgSrc = setProfileImg(contact, userId, allProfileImages);

	const getTheProfileImg = async () => {
		if (allProfileImages && userId && !allProfileImages[userId]) {
			try {
				const imgUrl = getUserProfileImageUrlThumbnail(userId);
				const isValid = await isValidImageUrl(imgUrl)
				console.log("isValid", isValid)
				if (isValid) {
					try {
						const imgObj = { [userId]: imgUrl };
						dispatch(updateProfileImage(imgObj));
					} catch (err) {
						console.log("contact ui error on profile img", err);
					}
				}
			} catch (err) {
				console.error("contact ui error on profile img", err);
			}
		}
	};

	useEffect(() => {
		if (allProfileImages && userId && allProfileImages[userId]) {
			const imgUrl = allProfileImages[userId];
			isValidImageUrl(imgUrl).then(isValid => {
				if (isValid) {
					updateProfileImg(imgUrl);
				} else {
					updateProfileImg('');
				}
			});
		} else {
			getTheProfileImg();
		}
	}, [allProfileImages, userId]);

	return (
		<li
			key={userId}
			className={` Contacts-hover position-relative flex items-center list-none p-0`}
			style={topElStyle}
		>
			<StyledBadge
				className="!bg-cyan-300 w-[30px] h-[30px] rounded-full text-white flex items-center justify-center"
				anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
				badgeContent={getBadgeIcon(contact)}
			>
				{console.log("contact", profileImg)}
				{profileImg ? (
					<Avatar
						className="!bg-cyan-300"
						name={contact.userName}
						imgSrc={profileImg}
						size={30}
						height={30}
						style={{ borderRadius: "50%" }}
					/>
				) : (
					<Avatar
						className="!bg-cyan-300"
						name={contact.userName}
						size={30}
						height={30}
						style={{ borderRadius: "50%" }}
					/>
				)}
			</StyledBadge>
			<div className="list-body" style={{ width: "65px" }}>
				<span
					className="list-title font600"
					style={{
						color: "#404585",
						fontSize: "14px",
						fontWeight: 700,
						width: "180px",
						display: 'block',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
					}}
				>
					{contact.name || contact.userName || ""}
					{contact.type && (
						<span className="list-title font500" style={{ color: "#666666" }}>
							(Vessel)
						</span>
					)}
				</span>

				{showRanks && contact.rankLevel2 && contact.rankLevel3 && <div
					style={{
						display: "flex",
						alignItems: "center",
						gap: "0.25rem",
						flexWrap: "wrap",
						width: '150px'
					}}
				>
					<div
						style={{
							// height: "20px",
							borderRadius: "24px",
							padding: "0px 8px",
							backgroundColor: getColorForRankAndRoles(contact),
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							color: "#fff",
							fontSize: "12px",
							fontWeight: "600"
						}}
					>
						{/* Electro Technical Officer */}
						{contact.rankLevel2.charAt(0).toUpperCase() + contact.rankLevel2.slice(1)}
					</div>
					<span
						style={{
							fontWeight: "400",
							fontSize: "13px",
							color: "#404585",
						}}
					>
						{/* Engine */}
						{contact.rankLevel3.charAt(0).toUpperCase() + contact.rankLevel3.slice(1)}
					</span>
				</div>}
			</div>
		</li>
	);
};

export default ContactUIFunctional;
